import { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
  headerActions?: React.ReactNode;
}

export const CollapsibleSection = ({
  title,
  icon,
  defaultOpen = true,
  children,
  className = '',
  headerActions,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={`bg-white rounded-xl border border-gray-200 overflow-hidden ${className}`}>
      <div
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') toggle();
        }}
        role="button"
        tabIndex={0}
        className="w-full flex items-center justify-between px-6 py-3 hover:bg-gray-50 transition-colors group"
      >
        <div className="flex items-center gap-3">
          {icon && (
            <span className="material-symbols-outlined text-gray-600 group-hover:text-primary transition-colors">
              {icon}
            </span>
          )}
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        </div>

        <div className="flex items-center gap-3">
          {headerActions && (
            <div onClick={(e) => e.stopPropagation()}>
              {headerActions}
            </div>
          )}

          <span
            className={`material-symbols-outlined text-gray-600 group-hover:text-primary transition-all duration-300 ${
              isOpen ? 'rotate-180' : ''
            }`}
          >
            expand_more
          </span>
        </div>
      </div>

      {isOpen && (
        <div className="border-t border-gray-200 px-6 py-4">
          {children}
        </div>
      )}
    </div>
  );
};
